// extracted by mini-css-extract-plugin
export default {"InactiveOverlay":"styles_InactiveOverlay__xqsuc","visible":"styles_visible__i3E1a","inner":"styles_inner__7M+Pr"};